import React from "react";
import Hero from "../components/sections/Hero";
import Services from "../components/sections/Services";
import Process from "../components/sections/Process";
import WhyUs from "../components/sections/WhyUs";
import Testimonials from "../components/sections/Testimonials";
import Contact from "../components/sections/Contact";

const Home = () => (
  <>
    <Hero />
    <Services />
    <Process />
    <WhyUs />
    <Testimonials />
    <Contact />
  </>
);

export default Home;
